exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2Wz62{background:#169ab5;border-radius:5px;color:#fff;padding:.25em 1em;font-size:21px;font-weight:16px;text-align:left;display:grid;grid-template-columns:1fr auto;-moz-column-gap:1em;column-gap:1em;align-items:center;height:75px}.index-module__popup-wrapper___k_DHG{display:grid;gap:1em}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2Wz62",
	"popup-wrapper": "index-module__popup-wrapper___k_DHG"
};